import Styled from 'styled-components';

export const Container = Styled.div`
	display: inline-block;
	min-width: ${props => props.minWidth && `${props.minWidth}px`};
	padding: 5px 0px;
	border-radius: 4px;
	background-color: ${({theme}) => theme.colors.white};
	border: ${({theme}) => `1px solid ${theme.colors.veryLightGray}`};
`;

export const ContentContainer = Styled.div`
	display: flex;
	flex-direction: column;
`;

export const PopupElement = Styled.div`
	cursor: ${props => !props.disabled && 'pointer'};
	box-sizing: border-box;
	display: flex;
	align-items: center;
	z-index: 1000;
	width: 100%;
	padding: 0 12px;
	background-color: ${({showFocus, disabled, theme}) => (showFocus && !disabled ? theme.colors.forecastPurpleLight : null)};
	&:hover {
		background-color: ${({disabled, theme}) => !disabled && theme.colors.forecastPurpleLight};
	}
`;

export const Element = Styled.div`
	flex-grow: 1;
	height: 100%;
`;
